export const DOCUMENT = typeof document !== 'undefined' ? document : null;
export const WINDOW = typeof window !== 'undefined' ? window : null;
